"use strict";
exports.__esModule = true;
exports.SocketIOContext = void 0;
var react_1 = require("react");
exports.SocketIOContext = react_1.createContext(undefined);
